// removed by extract-text-webpack-plugin
module.exports = {"usefulQuestions":"POIhF _20SLo _38YTw"};


//////////////////
// WEBPACK FOOTER
// ./reference/components/UsefulQuestions.css
// module id = 1326
// module chunks = 3